import React from 'react'
import styled from '@emotion/styled'
import { bool, string, oneOf } from 'prop-types'
import { makeImgResizerUrl } from '@jelly/utils'

import { BMonogram } from '../svgs/BMonogram'

const ThumbnailWrapper = styled.div`
	${({ showBoxShadow }) => showBoxShadow && `box-shadow:0 18px 22px 0 rgba(29, 45, 51, 0.17)`};
	border-radius: ${({ variant }) => (variant === 'avatar' ? `50%` : `5px`)};
	height: ${({ sizeDimension }) => `${sizeDimension}px`};
	max-width: ${({ sizeDimension }) => `${sizeDimension}px`};
	width: 100%;

	/* for default profile missing image */
	align-items: center;
	display: flex;
	background: ${({ theme }) => theme.colors.gray[400]};
	justify-content: space-around;
`

Thumbnail.propTypes = {
	/** Alternative text to display, most likely a name */
	alt: string.isRequired,
	/** Toggle box shadow off, default is on */
	showBoxShadow: bool,
	/** size of the thumbnail, small or large */
	size: oneOf(['small', 'large']),
	/** raw image source, will run through image resizer below */
	src: string,
	/** variation of the thumbnail to be displayed ('primary', 'avatar')*/
	variant: oneOf(['avatar', 'primary']),
}

/**
 * Thumbnail Component, default will display as a square with rounded corners
 * Takes in any image source and runs it through the image resizer
 * Variants:
 * - primary: square, rounded corners
 * - avatar: round,
 *
 * Size:
 * - small: 50px x 50px
 * - large: 140px x 140px
 *
 *
 * Image defaults to b monogram if no source is given
 * @component
 */
export function Thumbnail({ alt, showBoxShadow = false, size = 'small', src, variant = 'primary' }) {
	const sizeDimension = size === 'large' ? 140 : 50
	const pictureSrc = makeImgResizerUrl({ src: src, method: 'rc', w: sizeDimension, h: sizeDimension })
	return (
		<ThumbnailWrapper
			{...(src
				? { as: 'img', alt: alt, className: 'lazyload', 'data-src': pictureSrc }
				: { children: <BMonogram height={size === 'large' ? 50 : 25} width={size === 'large' ? 50 : 25} /> })}
			showBoxShadow={showBoxShadow}
			sizeDimension={sizeDimension}
			variant={variant}
		/>
	)
}
